import React from 'react'
import PropTypes from 'prop-types'
import checkCircleSvgPath from '../../../assets/icons/check-circle'
import Svg from '../Svg'

const checkCircleSymbol = props => (
  <Svg
    viewBox="0 0 35 34"
    width={props.width}
    height={props.height}
    svgPath={checkCircleSvgPath}
    color={props.color}
  />
)

checkCircleSymbol.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}

checkCircleSymbol.defaultProps = {
  width: 35,
  height: 34,
  color: '#85D43E',
}

export default checkCircleSymbol
